import React from "react";
import { Link } from "react-router-dom";
import FooterBottom from "./FooterBottom";

const FooterOne = () => {
  return (
    <footer>
      <div className="footer-area footer-bg">
        <div className="footer-top">
          <div className="container">
            <div className="footer-logo-area">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <div className="logo">
                    <Link to="/">
                      <img src="/img/logo/w_logo.svg" alt="Fix Right Handyman" />
                    </Link>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="footer-social-menu">
                    <ul className="list-wrap">
                      <li>
                        <a href="https://www.facebook.com/share/p/1Hmopvbtwa/" target="_blank" rel="noopener noreferrer">Facebook</a>
                      </li>
                      <li>
                        <a href="/">Twitter</a>
                      </li>
                      <li>
                        <a href="/">LinkedIn</a>
                      </li>
                      <li>
                        <a href="/">Instagram</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <div className="fw-title">
                    <h4 className="title">Contact Us</h4>
                  </div>
                  <div className="footer-content">
                    <p>B-30-03, RESIDENCE 1 UTARA NO. 42, JALAN 1/2B OFF JALAN IPOH, SELAYANG
                      68100 BATU CAVES SELANGOR</p>
                    <div className="footer-contact">
                      <ul className="list-wrap">
                        <li className="phone-addess">
                          <i className="fas fa-phone-alt"></i>
                          <a href="tel:+601135160242">+60 11-3516 0242</a>
                        </li>
                        <li className="email-addess">
                          <a href="mailto:frgrenovationworks@gmail.com">frgrenovationworks@gmail.com</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <div className="fw-title">
                    <h4 className="title">Our Links</h4>
                  </div>
                  <div className="fw-link-list">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/about">About</Link>
                      </li>
                      <li>
                        <Link to="/services">What We Do</Link>
                      </li>
                      <li>
                        <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6">
                <div className="footer-widget">
                  <div className="fw-title">
                    <h4 className="title">
                      <Link to="/services">Our Services</Link>
                    </h4>
                  </div>
                  <div className="fw-link-list">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/our-services#renovation">Renovation</Link>
                      </li>
                      <li>
                        <Link to="/our-services#electrition">Electrition</Link>
                      </li>
                      <li>
                        <Link to="/our-services#plumbing">Plumbing</Link>
                      </li>
                      <li>
                        <Link to="/our-services#painting">Painting</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* footer bottom */}
        <FooterBottom />
      </div>
    </footer>
  );
};

export default FooterOne;